import { render, staticRenderFns } from "./DocumentLinks.vue?vue&type=template&id=58e5f74f&scoped=true"
import script from "./DocumentLinks.vue?vue&type=script&lang=js"
export * from "./DocumentLinks.vue?vue&type=script&lang=js"
import style0 from "./DocumentLinks.vue?vue&type=style&index=0&id=58e5f74f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e5f74f",
  null
  
)

export default component.exports